import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import LoadBoard from './components/LoadBoard';
import Invoices from './components/Invoices';
import Carriers from './components/Carriers';
import QuickBooksSettings from './components/QuickBooksSettings';
import QuickBooksCallback from './components/QuickBooksCallback';
import AccountSettings from './components/AccountSettings';
import DriverSettings from './components/DriverSettings';
import AgentApprovals from './components/AgentApprovals';
import PrivateRoute from './components/PrivateRoute';
// import Chatbot from './components/Chatbot';
import Navbar from './components/Navbar';
import { PrivacyPolicy, TermsOfService } from './components/LegalPages';

function AuthenticatedLayout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      {children}
      {/* <Chatbot /> */}
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        
        {/* Protected routes */}
        <Route path="/" element={
          <PrivateRoute>
            <AuthenticatedLayout>
              <Dashboard />
            </AuthenticatedLayout>
          </PrivateRoute>
        } />
        
        <Route path="/tenders" element={
          <PrivateRoute>
            <AuthenticatedLayout>
              <LoadBoard />
            </AuthenticatedLayout>
          </PrivateRoute>
        } />
        
        {/* Old paths: Shipments folded into the dashboard, Loads renamed Tenders */}
        <Route path="/shipments" element={<Navigate to="/" replace />} />
        <Route path="/load-board" element={<Navigate to="/tenders" replace />} />
        
        <Route path="/carriers" element={
          <PrivateRoute>
            <AuthenticatedLayout>
              <Carriers />
            </AuthenticatedLayout>
          </PrivateRoute>
        } />

        <Route path="/invoices" element={
          <PrivateRoute>
            <AuthenticatedLayout>
              <Invoices />
            </AuthenticatedLayout>
          </PrivateRoute>
        } />
        
        <Route path="/agent-approvals" element={
          <PrivateRoute>
            <AuthenticatedLayout>
              <AgentApprovals />
            </AuthenticatedLayout>
          </PrivateRoute>
        } />

        <Route path="/settings/quickbooks" element={
          <PrivateRoute>
            <AuthenticatedLayout>
              <QuickBooksSettings />
            </AuthenticatedLayout>
          </PrivateRoute>
        } />

        <Route path="/settings/account" element={
          <PrivateRoute>
            <AuthenticatedLayout>
              <AccountSettings />
            </AuthenticatedLayout>
          </PrivateRoute>
        } />

        <Route path="/settings/drivers" element={
          <PrivateRoute>
            <AuthenticatedLayout>
              <DriverSettings />
            </AuthenticatedLayout>
          </PrivateRoute>
        } />
        
        {/* QuickBooks OAuth Callback - minimal layout */}
        <Route path="/quickbooks/callback" element={<QuickBooksCallback />} />

        {/* Public legal pages - no auth required */}
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />

        {/* Catch all route - redirect to dashboard */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;